import { createFileRoute } from "@tanstack/react-router";
import { WorkspaceSubscriptionPage } from "@/features/workspaces/subscription.page";

export const Route = createFileRoute("/_authenticated/workspaces/$slug/subscription")({
  component: WorkspaceSubscriptionPage,
});

export const WorkspaceSubscriptionRoute = Route;
